import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import normalize from '../normalizers/schedulings-normalizer';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts('appointment-form', 'schedulings-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'schedulings',
  ],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
  meta: {},
  ids: [],
  entities: {},
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SEND: {
      return {
        ...initialState,
        sending: true,
      };
    }

    case consts.SUCCEED: {
      const { availableProviders, ...meta } = payload;
      const {
        result: ids,
        entities: { availableProviders: entities },
      } = normalize(availableProviders);

      return {
        ...state,
        sending: false,
        succeed: true,
        ids,
        entities,
        meta,
      };
    }

    case APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/schedulings-req.js